import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Product } from '../../types/content';
import { useBrand } from '../../contexts/BrandContext';
export function ProductCard({
  product
}: {
  product: Product;
}) {
  const {
    productImage
  } = useBrand();
  return <li className="flex" data-id="element-235" data-mp="1jcon3gg251r0">
      <Link to={`/shop/${product.slug}`} className="group flex w-full flex-col overflow-hidden rounded-brand border border-ink/15 bg-cream-light transition-colors duration-150 ease-republic hover:border-ink" data-id="element-236" data-mp="1jbdl9m66a42j">
        <div className="overflow-hidden bg-stone-light" data-id="element-237" data-mp="1t52qedmsagfa">
          <img src={productImage(product.slug, product.image)} alt={`${product.name}, ${product.form}`} className="aspect-square w-full object-cover transition-transform duration-300 ease-republic group-hover:scale-[1.02]" data-id="element-238" data-mp="2717y43qhrsms" />
        </div>

        <div className="flex flex-1 flex-col p-6" data-id="element-239" data-mp="7qgjyxqyoe2c">
          <div className="flex items-center gap-2" data-id="element-240" data-mp="7rrm6t4rddrc">
            <span className={`text-[0.625rem] uppercase tracking-label ${product.category === 'FDA-approved' ? 'text-brick' : 'text-ink-muted'}`} data-id="element-241" data-mp="3gt1hl7x117w9">
              {product.status}
            </span>
          </div>

          <h3 className="mt-3 font-serif text-2xl leading-tight text-ink" data-id="element-242" data-mp="3vhegodrev6uz">{product.name}</h3>
          <p className="mt-2 text-sm text-ink-muted" data-id="element-243" data-mp="3dc77mnppldd">
            {product.form} · {product.strength}
          </p>
          <p className="mt-4 text-sm leading-relaxed text-ink-soft" data-id="element-244" data-mp="8bdrgawvjqqf">{product.tagline}</p>

          <div className="rule mt-auto flex items-end justify-between gap-4 pt-5" data-id="element-245" data-mp="daqditfx8try">
            <div data-id="element-246" data-mp="iacn8swjjrw0">
              <p className="font-serif text-3xl leading-none text-ink" data-id="element-247" data-mp="iaw7whdksudq">
                ${product.price}
                <span className="ml-2 font-sans text-xs text-ink-muted" data-id="element-248" data-mp="2f3el1ezlm3dj">{product.cadence}</span>
              </p>
              <p className="mt-2 text-xs text-ink-muted" data-id="element-249" data-mp="2k2r8a0udtcgn">{product.priceNote}</p>
            </div>
            <ArrowRightIcon className="mb-1 h-5 w-5 shrink-0 text-brick transition-transform duration-200 ease-republic group-hover:translate-x-1" strokeWidth={1.5} data-id="element-250" data-mp="2c22znijc7ed5" />
          </div>
        </div>
      </Link>
    </li>;
}